module.exports = __webpack_public_path__ + "img/header-memoireRingsColored@2x.fa5b7d1.webp";